import React from 'react';

import { PredictionsInfoContext } from '@futrli/predict/forecast/detail/context/predictions-info-context';
import { UILoader } from '@futrli/ui-components';
import { LiveReportDetail } from '@futrli-sdk/predict';

import { OnboardingContextProvider } from '../../onboarding.context';
import { ReportBuilderContextProvider } from '../../report-builder.context';
import { ReportIntlProvider } from '../../components/report-intl-provider/report-intl-provider';
import { StandaloneReportContent } from './standalone-report-content';

import styles from './standalone-report-container.scss';

interface Props {
  organisationId: string;
  workspaceId: string;
  report: LiveReportDetail;
}

export const StandaloneReportContainer = ({ organisationId, workspaceId, report }: Props) => {
  if (!report) {
    return (
      <div className={styles.loaderContainer}>
        <UILoader />
      </div>
    );
  }

  return (
    <div className={styles.reportContainer}>
      <PredictionsInfoContext>
        <OnboardingContextProvider>
          <ReportBuilderContextProvider
            report={report}
            viewPage
            patchReport={(_reportId: string, _data: Partial<LiveReportDetail>) => Promise.resolve()}
            workspaceId={workspaceId}
            organisationId={organisationId}
          >
            <ReportIntlProvider locale={report.locale || 'en-GB'}>
              <StandaloneReportContent isDashboard={report.orientation === 'dashboard'} />
            </ReportIntlProvider>
          </ReportBuilderContextProvider>
        </OnboardingContextProvider>
      </PredictionsInfoContext>
    </div>
  );
};
